export enum BinaryByteUnitPrefix
{
  base  = 0,
  kilo  = 1,
  mega  = 2,
  giga  = 3,
  tera  = 4,
  peta  = 5,  
  exa   = 6,
  zetta = 7,
  yotta = 8,
  ronna = 9,
  quetta = 10
}